import React from "react";
import Editor from "../../Editors/DateTimeInput";

const DateTimeEditor = props => {
  return <Editor {...props} eventTimezone={props.eventTimezone} />;
};

export default DateTimeEditor;
